import type { SupportedRepubName } from './types';

export type TrackingConfig = {
  landingSubscriptionClick: {
    eventName: 'landing_page_cta';
    getEventData: (params: {
      isUpgrade: boolean;
      price: string;
      selection: 'Essential' | 'Premium';
      term: string | undefined;
    }) => Record<string, any>;
  };
};

/**
 * Tracking configurations for each republic
 */
export const TRACKING_CONFIGS = {
  GZ: {
    landingSubscriptionClick: {
      eventName: 'landing_page_cta',
      getEventData: ({ price, term }) => ({
        eventLabel: 'Landing Page CTA',
        product: price,
        selection: term,
      }),
    },
  },
  OC: {
    landingSubscriptionClick: {
      eventName: 'landing_page_cta',
      getEventData: ({ isUpgrade, price, selection, term }) => ({
        eventLabel: isUpgrade ? 'Plan Upgrade CTA' : 'Landing Page CTA',
        product: `${term} - ${price}`,
        referrerUrl: document.referrer,
        upgradeOrPurchase: isUpgrade ? 'Upgrade' : 'Purchase',
        ...(isUpgrade ? {} : { selection }),
      }),
    },
  },
  US: {
    landingSubscriptionClick: {
      eventName: 'landing_page_cta',
      getEventData: ({ price, term }) => ({
        eventLabel: 'Landing Page CTA',
        product: price,
        selection: term,
      }),
    },
  },
  WS: {
    landingSubscriptionClick: {
      eventName: 'landing_page_cta',
      getEventData: ({ price, term }) => ({
        eventLabel: 'Landing Page CTA',
        product: price,
        selection: term,
      }),
    },
  },
} satisfies Record<SupportedRepubName, TrackingConfig>;
